import { ReactElement } from 'react';

import { GeneratedContent } from '@backrs_ui/common-ui/src/models/generatedContent';

import { Theme, SxProps, Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { getMarkdownComponents } from '../AskLubavButtons/AskLubavResponse';

type NuggetGeneratedContentProps = Readonly<{
  variant: GeneratedContent;
}>;

export const NuggetGeneratedContent = ({ variant }: NuggetGeneratedContentProps): ReactElement => {
  if (!variant.content) {
    return <></>;
  }

  return (
    <Box sx={contentSx}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={getMarkdownComponents('LARGE')}>
        {variant.content}
      </ReactMarkdown>
    </Box>
  );
};

const contentSx: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-none'],
});
